import React from 'react';
import {
  Circle,
  Loader,
  Ban,
  AlertTriangle,
  CheckCircle,
} from 'lucide-react';
import { getStatusMeta } from '../utils/format';
import styles from './StatusBadge.module.css';

const ICONS = {
  circle: Circle,
  loader: Loader,
  ban: Ban,
  'alert-triangle': AlertTriangle,
  'check-circle': CheckCircle,
};

export function StatusBadge({ status, size = 'sm' }) {
  const meta = getStatusMeta(status);
  const Icon = ICONS[meta.icon] || Circle;
  const className = `${styles.badge} ${styles[`badge--${size}`]} ${styles[`status--${status}`]}`;

  return (
    <span className={className} style={{ color: meta.color }}>
      <Icon size={size === 'lg' ? 16 : 12} aria-hidden="true" />
      <span>{meta.label}</span>
    </span>
  );
}
